var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hasModalCard":"","customClass":_vm.modalCardClasses,"active":_vm.isOpen,"width":_vm.width,"canCancel":_vm.canCancel},on:{"close":function($event){return _vm.$emit('onClose')}}},[_c('div',{staticClass:"card academy-custom-card"},[_c('div',{staticClass:"card-content"},[_c('div',[_vm._t("modal-card-content")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }